var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIntermediate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.5 15.5H5.5V21.5H4.5V15.5Z",
    fill: "#E4E4E4",
    stroke: "#39393D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20L17 9L20 16H4V2Z",
    fill: "#FF8F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9L20 2H4V16H20L17 9ZM16.9669 14L14.8241 9L16.9669 4H6V14H16.9669Z",
    fill: "#39393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIntermediate);
export default __webpack_public_path__ + "static/media/list_intermediate.96465e910564bc463487d2071ebb5c2f.svg";
export { ForwardRef as ReactComponent };